import React, { useEffect, useRef, useState } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import '../styles/sidebar.css';
import { ChevronDown, ChevronRight } from 'react-feather';
import Tooltip from '@mui/material/Tooltip';
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react';

const Sidebar = ({ moduleAccess }) => {
    const userRoleAccess = useSelector((state) => state.auth.userRoles);
    const location = useLocation();
    const isSideBar = useSelector((state) => state.auth.isExpand);
    const [expandedMenus, setExpandedMenus] = useState({});
    const [isMasterCollapsed, setIsMasterCollapsed] = useState(false);
    const prevExpandedState = useRef({});
    const isActive = (path) => location.pathname === path ? 'active' : '';

    useEffect(() => {
        if (isSideBar) {
            prevExpandedState.current = { ...expandedMenus };
            setExpandedMenus({});
        } else {
            setExpandedMenus(prevExpandedState.current);
        }
    }, [isSideBar]);

    const toggleAccordion = (menuId) => {
        setExpandedMenus((prevState) => ({
            ...prevState,
            [menuId]: !prevState[menuId],
        }));
    };

    const toggleMasterCollapse = () => {
        setIsMasterCollapsed(!isMasterCollapsed);
    };

    const handleMouseEnter = () => {
        if (isSideBar) {
            setExpandedMenus(prevExpandedState.current);
        }
    };

    const handleMouseLeave = () => {
        if (isSideBar) {
            prevExpandedState.current = { ...expandedMenus };
            setExpandedMenus({});
        }
    };

    useEffect(() => {
        if (!isSideBar) {
            document.body.classList.add('sidenav-toggled');
        } else {
            document.body.classList.remove('sidenav-toggled');
        }
    }, [isSideBar]);

    return (
        <div id="layoutSidenav_nav" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <nav className="sidenav shadow-right sidenav-light">
                <div className="sidenav-menu">
                    <div className="nav accordion" id="accordionSidenav">
                        {userRoleAccess?.non_master?.map((menu) => (
                            <div key={menu.id}>
                                <NavLink
                                    className={({ isActive }) =>
                                        `nav-link ${isActive ? "active" : ""}`
                                    }
                                    to={menu.slug ? `/${menu.slug}` : "javascript:void(0);"}
                                    onClick={menu.submenu.length > 0 ? () => toggleAccordion(menu.id) : null}
                                >
                                    <div className="nav-link-icon">
                                        <Tooltip title={menu.module_name}>
                                            <Icon icon={menu.icon} width="24" height="24" />
                                        </Tooltip>
                                    </div>
                                    <span className="pagetitle">{menu.module_name}</span>
                                    {menu.submenu.length > 0 && (
                                        <div className="sidenav-collapse-arrow">
                                            <ChevronRight size={18} strokeWidth={2} />
                                        </div>
                                    )}
                                </NavLink>
                                {menu.submenu.length > 0 && (
                                    <div
                                        className={`collapse ${expandedMenus[menu.id] ? "show" : ""}`}
                                        id={`collapse${menu.id}`}
                                        data-bs-parent="#accordionSidenav"
                                    >
                                        <nav className="sidenav-menu-nested nav accordion">
                                            {menu.submenu.map((submenu) => (
                                                <NavLink
                                                    key={submenu.id}
                                                    className={({ isActive }) =>
                                                        `nav-link ${isActive ? "active" : ""}`
                                                    }
                                                    to={`/${submenu.slug}`}
                                                >
                                                    <span className="pagetitle subTitle">
                                                        {submenu.module_name}
                                                    </span>
                                                </NavLink>
                                            ))}
                                        </nav>
                                    </div>
                                )}
                            </div>
                        ))}

                        {userRoleAccess?.masters?.length > 0 && (
                            <div>
                                <div className="sidenav-menu-heading" onClick={toggleMasterCollapse} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                    <span>{isSideBar ? 'MA' : 'Master'}</span>
                                    <div className="ms-auto">
                                        {isMasterCollapsed ? <ChevronRight size={18} strokeWidth={2} /> : <ChevronDown size={18} strokeWidth={2} />}
                                    </div>
                                </div>
                                {!isMasterCollapsed && userRoleAccess?.masters?.map((menu) => (
                                    <div key={menu.id}>
                                        <NavLink
                                            className={({ isActive }) =>
                                                `nav-link ${isActive ? "active" : ""}`
                                            }
                                            to={menu.slug ? `/${menu.slug}` : "javascript:void(0);"}
                                        >
                                            <div className="nav-link-icon">
                                                <Tooltip title={menu.module_name}>
                                                    <Icon icon={menu.icon} width="24" height="24" />
                                                </Tooltip>
                                            </div>
                                            <span className="pagetitle">{menu.module_name}</span>
                                        </NavLink>
                                    </div>
                                ))}
                            </div>
                        )}
                        
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Sidebar;



